import * as components from './components';

export default [
    {
        path: '/rma',
        component: components.RMA,
        name: 'rma'
    }
];


// WEBPACK FOOTER //
// ./ClientApp/app/rma/routes.js